"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityAudit = void 0;
var ActivityAudit;
(function (ActivityAudit) {
    let ActivityType;
    (function (ActivityType) {
        ActivityType["register"] = "register";
        ActivityType["enroll"] = "enroll";
        ActivityType["createRegisterRule"] = "createRegisterRule";
        ActivityType["deleteRegisterRule"] = "deleteRegisterRule";
        ActivityType["modifyRegisterRule"] = "modifyRegisterRule";
        ActivityType["createEnrollmentRule"] = "createEnrollmentRule";
        ActivityType["deleteEnrollmentRule"] = "deleteEnrollmentRule";
        ActivityType["modifyEnrollmentRule"] = "modifyEnrollmentRule";
        ActivityType["createSession"] = "createSession";
        ActivityType["createStudentRegistration"] = "createStudentRegistration";
        ActivityType["createCourseEnrollment"] = "createCourseEnrollment";
        ActivityType["executeAutoRules"] = "executeAutoRules";
        ActivityType["executeAutoEnrollmentRule"] = "executeAutoEnrollmentRule";
        ActivityType["executeAutoRegisterRule"] = "executeAutoRegisterRule";
        ActivityType["cachedContent"] = "cachedContent";
        ActivityType["assignApps"] = "assignApps";
    })(ActivityType = ActivityAudit.ActivityType || (ActivityAudit.ActivityType = {}));
    let ErrorMessage;
    (function (ErrorMessage) {
        ErrorMessage["SESSION_NOT_FOUND"] = "Session not found!";
        ErrorMessage["STUDENT_REGISTRATION_NOT_FOUND"] = "Student registration not found!";
        ErrorMessage["STUDENT_REGISTRATION_IS_NOT_PENDING"] = "Student registration is not pending!";
        ErrorMessage["COURSE_ENROLLMENT_NOT_FOUND"] = "Course enrollment not found!";
        ErrorMessage["FACILITY_NOT_FOUND"] = "Facility not found!";
        ErrorMessage["INMATE_NOT_FOUND"] = "Inmate not found or unable to load inmate information!";
        ErrorMessage["CANVAS_COURSE_NOT_FOUND"] = "Canvas course not found!";
        ErrorMessage["CANVAS_SECTION_NOT_FOUND"] = "Canvas section not found!";
        ErrorMessage["COULD_NOT_CREATE_STUDENT_REGISTRATION"] = "Could not create student registration!";
        ErrorMessage["COULD_NOT_CREATE_COURSE_ENROLLMENT"] = "Could not create course enrollment!";
        ErrorMessage["STUDENT_IS_NOT_REGISTERED"] = "Student is not registered!";
        ErrorMessage["COULD_NOT_ENROLL_INTO_COURSE"] = "Could not enroll into course!";
        ErrorMessage["COULD_NOT_REGISTER_STUDENT"] = "Could not register student!";
        ErrorMessage["COULD_NOT_GET_EXISTING_STUDENT"] = "Could not get existing student from Canvas!";
        ErrorMessage["COULD_NOT_IMPORT_JPAY_STUDENT"] = "Could not import JPay student!";
        ErrorMessage["AUTO_REGISTER_RULE_NOT_FOUND"] = "AutoRegister rule not found!";
        ErrorMessage["AUTO_ENROLL_RULE_NOT_FOUND"] = "AutoEnroll rule not found!";
        ErrorMessage["JPAY_TABLET_ORDER_ERROR"] = "Could not handle JPay Tablet Order";
        ErrorMessage["INMATE_LIST_IS_EMPTY"] = "Inmates list is empty!";
        ErrorMessage["AUTO_RULE_PARAMETERS_EMPTY"] = "Auto rule parameters were empty, but there were inmates to process!";
        ErrorMessage["APP_PURCHASE_TOKEN_FAILURE"] = "Purchase token could not be retrieved!";
        ErrorMessage["APP_ORDER_FAILURE"] = "App could not be ordered!";
        ErrorMessage["CUSTODY_PIN_FAILURE"] = "Could not retrieve custody pin for inmate!";
        ErrorMessage["INMATE_JWT_FAILURE"] = "Could not retrieve jwt for inmate!";
        ErrorMessage["INMATE_APP_CONFIGURATION_ERROR"] = "App configuration error for inmate!";
        ErrorMessage["INMATE_ORDER_DATA_FAILURE"] = "Could not get inmate order data!";
        ErrorMessage["COULD_NOT_CANCEL_ORDER"] = "Could not cancel app order for inmate";
        ErrorMessage["COULD_NOT_GET_ORDER_ACTION"] = "Could not get order actions for inmate app order!";
        ErrorMessage["COULD_NOT_GET_DUPLICATE_ORDERS"] = "Could not get duplicate app order information!";
        ErrorMessage["JPAY_PASSWORD_INVALID"] = "Fixed JPAY password is not correct! Please update it";
        ErrorMessage["ATTEMPT_TO_FIX_EXISTING_REGISTRATION_FAILED"] = "Attempt to fix existing registration failed";
    })(ErrorMessage = ActivityAudit.ErrorMessage || (ActivityAudit.ErrorMessage = {}));
})(ActivityAudit = exports.ActivityAudit || (exports.ActivityAudit = {}));
//# sourceMappingURL=activityAudit.js.map